<template>
	<div>
		<h4 class="section-title">Import HHAs</h4>
		<a :href="`${api_base}providers_template.xlsx`">Click here to download template</a>
		<p class="text-success">{{ message }}</p>
		<vue-dropzone ref="dropzone" id="dropzone" class="mb-3"
    		:options="dropzoneOptions"
    		@vdropzone-success="fileUploaded">
    	</vue-dropzone>
	</div>
</template>

<script>
	export default{
		data : function(){
			return {
				dropzoneOptions: {
					url : this.config.UPLOAD_PROVIDERS_CSV,
					thumbnailWidth: 50,
					maxFilesize: 50,
					maxFiles : 1,
					addRemoveLinks : true,
					headers : {
						'Autrollization' : localStorage.getItem('token')
					},
					api_base : this.config.API_BASE
			    },
			    message : ''
			}
		},

		methods : {
			fileUploaded : function(file, response){
				console.log(response);
				this.message = response.message;
				this.$refs.dropzone.removeAllFiles();
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/admin/providers/AdminProviderImportComponent.vue